@if ({value: activeTheme | async}; as activeTheme) {
  <ul>
    @for (item of items; track item) {
      <li
        class="sidemenu__{{ type }}"
    [ngClass]="[
      item?.firstLevel && item?.active ? 'sidemenu-theme--' + activeTheme?.value : '',
      item?.active ? 'active' : '',
      item?.expanded ? 'expanded' : ''
    ]">
        @if (item.relative !== '/#nolink' && item.relative !== '/#nocategory' && item.relative !== '/#category') {
          <a (click)="clickMenuItem(item); false"
            class="sidemenu__button sidemenu__button__{{ type }}"
            href="{{ item.relative }}"
            [attr.aria-expanded]="item?.below?.length ? item.expanded : null"
            [attr.aria-controls]="item?.below?.length ? (item.title | slugify) : null"
            [class.with-submenu]="item?.below?.length"
            [attr.aria-haspopup]="item?.below?.length !== 0"
            [attr.aria-current]="item.active"
            [class.active]="item.active"
            (mousedown)="animateRipple($event)"
            [attr.data-test-id]="'sidemenu-link-' + (item?.title?.toLowerCase() | slugify)"
            [class.sidemenu__item--third-level]="nestingLevel >= 2"
            [attr.data-slug-title]="item?.sluggedTitle"
            >
            <span class="sidemenu__item-title" [class.sidemenu__item-title--nested]="nestingLevel > 0">
              {{item.title}}
              @if (item?.below?.length) {
                <icon class="chevron expand small" glyph="chevron-right" size="small"></icon>
              }
            </span>
          </a>
        }
        @if (item.relative === '/#nolink' || item.relative === '/#nocategory' || item.relative === '/#category') {
          <button
            (click)="clickMenuItem(item); false"
            class="sidemenu__button sidemenu__button__{{ type }}"
            [attr.aria-expanded]="item?.below?.length ? item.expanded : null"
            [attr.aria-controls]="item?.below?.length ? (item.title | slugify) : null"
            [class.with-submenu]="item?.below?.length"
            [attr.aria-haspopup]="item?.below?.length !== 0"
            [attr.aria-current]="item.active"
            [class.active]="item.active"
            (mousedown)="animateRipple($event)"
            [attr.data-test-id]="'sidemenu-link-' + (item?.title?.toLowerCase() | slugify)"
            [attr.data-slug-title]="item?.sluggedTitle"
            [class.sidemenu__button--third-level]="nestingLevel === 1 && item?.below?.length"
            >
            <span class="sidemenu__item-title" [class.sidemenu__item-title--nested]="nestingLevel > 0">
              {{item.title}}
              <icon class="chevron small" glyph="chevron-right" size="small"></icon>
            </span>
          </button>
        }
        @if (item?.below?.length && item.expanded) {
          <sidemenu-item [items]="item.below" [nestingLevel]="nestingLevel + 1"></sidemenu-item>
        }
      </li>
    }
  </ul>
}
